"use strict";

export function isValidIsraeliId(id, allowTest) {
  id = String(id ?? "").replace(/\D/g, "");
  if (!id || id.length > 9) return false;
  id = id.padStart(9, "0");
  if (id === "000000000") return !!allowTest;
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    let value = Number(id[i]) * ((i % 2) + 1);
    if (value > 9) value = Math.floor(value / 10) + (value % 10);
    sum += value;
  }
  return sum % 10 === 0;
}

export function normalizeIsraeliId(id) {
  return String(id ?? "").replace(/\D/g, "").padStart(9, "0");
}

export function israeliIdFieldIsValid(value, field = {}) {
  const digits = String(value ?? "").replace(/\D/g, "");
  if (!digits) {
    return !field.required;
  }
  return isValidIsraeliId(value, field.allow_test);
}

export const REQUIRED_FIELD_HE = "נא למלא שדה זה";

export function clientFieldValidationMessage(value, field = {}) {
  const raw = String(value ?? "");
  const trimmed = raw.trim();
  const required = !!field.required;
  if (field.validate === "israeli_id") {
    const digits = raw.replace(/\D/g, "");
    if (!digits) {
      return required ? field.error_blank || REQUIRED_FIELD_HE : "";
    }
    if (!isValidIsraeliId(raw, field.allow_test)) {
      return field.error_message || REQUIRED_FIELD_HE;
    }
    return "";
  }
  if (required && !trimmed) {
    return field.error_blank || field.error_message || REQUIRED_FIELD_HE;
  }
  return "";
}

function findIsraeliIdInput(form, field) {
  const dataName = field?.data_name;
  if (!form || !dataName) {
    return null;
  }
  const escaped = typeof CSS !== "undefined" && CSS.escape ? CSS.escape(dataName) : dataName;
  return (
    form.querySelector(`[data-name="${escaped}"]`) ||
    form.querySelector(`#${escaped}`) ||
    form.elements?.[dataName] ||
    null
  );
}

export function readCardHolderIdFromForm(form, fields) {
  const list = Array.isArray(fields)
    ? fields.filter((field) => field?.validate === "israeli_id")
    : [];
  if (!list.length) {
    return { ok: true };
  }
  for (const field of list) {
    const input = findIsraeliIdInput(form, field);
    const value = input?.value ?? "";
    if (!israeliIdFieldIsValid(value, field)) {
      form?.dispatchEvent?.(
        new CustomEvent("yummi-validate", { detail: { markInvalid() {} } })
      );
      return { ok: false };
    }
  }
  const holderField = list.find((field) => field.validate === "israeli_id") || list[0];
  const input = findIsraeliIdInput(form, holderField);
  const digits = String(input?.value ?? "").replace(/\D/g, "");
  if (!digits) {
    return { ok: true };
  }
  return { ok: true, cardHolderId: digits.padStart(9, "0") };
}
